import React from 'react';
import PropTypes from 'prop-types';

import styles from './playerPill.scss';

const PlayerPill = ({ player, emailInvite, showRemoveButton, onRemoveEmail, onRemovePlayer }) => {
    const isEmail = emailInvite !== null;
    const handleOnRemovePlayer = () => {
        onRemovePlayer(player);
    };

    const handleOnRemoveEmail = () => {
        onRemoveEmail(emailInvite);
    };

    return (
        <div className={styles.pillContainer}>
            <div className={styles.name}>{isEmail ? emailInvite.email : player.source.displayName}</div>
            {showRemoveButton && (
                <div className="close-icon" onClick={isEmail ? handleOnRemoveEmail : handleOnRemovePlayer}>
                    <i className={`${styles.closeButton} utr utr-close`} />
                </div>
            )}
        </div>
    );
};

PlayerPill.defaultProps = {
    player: null,
    emailInvite: null,
    onRemovePlayer: () => {},
    onRemoveEmail: () => {},
};

PlayerPill.propTypes = {
    player: PropTypes.instanceOf(Object),
    emailInvite: PropTypes.instanceOf(Object),
    showRemoveButton: PropTypes.bool.isRequired,
    onRemovePlayer: PropTypes.func,
    onRemoveEmail: PropTypes.func,
};

export default PlayerPill;
